import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/constants";

export default function Hero() {
  const { t } = useTranslation();

  const cols = [
    t("hero.previewCols.category"),
    t("hero.previewCols.product"),
    t("hero.previewCols.seller"),
    t("hero.previewCols.price"),
    t("hero.previewCols.qc"),
    t("hero.previewCols.shipping"),
    t("hero.previewCols.updated"),
  ];

  const rows = ["r1", "r2", "r3", "r4"].map(
    (k) => t(`hero.previewRows.${k}`, { returnObjects: true }) as unknown as string[]
  );

  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2 lg:items-center">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-table-line"></i>
            {t("hero.eyebrow")}
          </span>
          <h1 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-foreground-950 md:text-5xl">
            {t("hero.title")}
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            {t("hero.subtitle")}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              {t("cta.explore")}
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-accent-600"
            >
              {t("cta.buyNow")}
              <i className="ri-shopping-bag-3-line"></i>
            </a>
          </div>

          <p className="mt-6 flex items-start gap-2 text-xs text-foreground-500">
            <i className="ri-information-line mt-0.5 text-primary-500"></i>
            <span>{t("trust")}</span>
          </p>
        </div>

        <div className="w-full">
          <div className="rounded-2xl border border-background-200 bg-white p-4 md:p-5">
            <div className="flex items-center justify-between border-b border-background-100 pb-3">
              <h2 className="text-sm font-semibold text-foreground-950">
                {t("hero.previewTitle")}
              </h2>
              <span className="flex items-center gap-1 rounded-full bg-primary-50 px-2 py-1 text-xs font-medium text-primary-700">
                <i className="ri-database-2-line"></i>
                {t("hero.eyebrow")}
              </span>
            </div>
            <div className="mt-3 overflow-x-auto">
              <table className="w-full min-w-[520px] text-left text-xs">
                <thead>
                  <tr className="text-foreground-500">
                    {cols.map((col) => (
                      <th key={col} className="whitespace-nowrap px-2 py-2 font-medium">
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, i) => (
                    <tr key={i} className="border-t border-background-100">
                      {row.map((cell, j) => (
                        <td
                          key={j}
                          className={`whitespace-nowrap px-2 py-2.5 ${
                            j === 0 ? "font-medium text-foreground-900" : "text-foreground-600"
                          }`}
                        >
                          {j === 3 ? (
                            <span className="text-foreground-700">{cell}</span>
                          ) : j === 4 ? (
                            <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2 py-0.5 text-primary-700">
                              <i className="ri-check-line"></i>
                              {cell}
                            </span>
                          ) : (
                            cell
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}